import { Cookies, } from 'react-cookie';
import { combineReducers, } from 'redux';
import appState from './appState';
import performance from '../scenes/Performance/reducer';
import adjustment from '../scenes/Adjustment/reducer';
import prediction from '../scenes/Prediction/reducer';
import symbolSummary from '../scenes/SymbolSummary/reducer';

import * as types from '../constant/actionTypes';

const reducer = combineReducers({
  appState,
  performance,
  adjustment,
  prediction,
  symbolSummary,
});

export default (state, action) => {
  // Logout
  if (action.type === types.UNAUTH_USER) {
    const cookies = new Cookies();
    cookies.set('_t', '', { expires: new Date(0), path: '/', });
    cookies.set('_c', '', { expires: new Date(0), path: '/', });
    window.onbeforeunload = undefined;
    state = undefined;
    setTimeout(() => window.location.reload(), 500);
  }
  // 401 errhandle
  if (action.payload && action.payload.statusCode === 401) {
    const cookies = new Cookies();
    cookies.set('_t', '', { expires: new Date(0), path: '/', });
    cookies.set('_c', '', { expires: new Date(0), path: '/', });
    state = undefined;
    setTimeout(() => window.location.reload(), 500);
  }
  return reducer(state, action);
};



// WEBPACK FOOTER //
// ./src/reducers/index.js